/**
 * Grimstad Seilforening-logo.
 *
 * Sirkulær logo med GSF-merket. Støtter tre størrelser.
 */

type LogoSize = 'sm' | 'md' | 'lg';

const sizeClasses: Record<LogoSize, string> = {
  sm: 'w-10 h-10',
  md: 'w-16 h-16',
  lg: 'w-24 h-24 md:w-28 md:h-28',
};

export function GsfLogo({ size = 'md', className = '' }: { size?: LogoSize; className?: string }) {
  return (
    <img
      src="/gsf-logo.png"
      alt="Grimstad Seilforening"
      className={`${sizeClasses[size]} rounded-full bg-white/95 p-1 shadow-lg shadow-black/30 ring-1 ring-white/10 ${className}`}
      draggable={false}
    />
  );
}

/** Racecloud-logo (seilbåt i sky + «racecloud.no»). Lys logo → hvit bakgrunn. */
export function RcLogo({ className = '' }: { className?: string }) {
  return (
    <img
      src="/rclogo.png"
      alt="Racecloud"
      className={`h-14 w-auto rounded-lg bg-white p-1.5 shadow-lg shadow-black/30 ${className}`}
      draggable={false}
    />
  );
}
